import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

export * from './palettes';

export const ThemeProvider = MuiThemeProvider;
